module.exports = __webpack_public_path__ + "static/agabi-4796570748742ed673bde23934ec7145.png";